/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Admin API
 * Areeb Admin REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  DeleteImageDto,
  UploadImageResponseDto,
} from '../models/index';
import {
    DeleteImageDtoFromJSON,
    DeleteImageDtoToJSON,
    UploadImageResponseDtoFromJSON,
    UploadImageResponseDtoToJSON,
} from '../models/index';

export interface DeleteImagesRequest {
    deleteImageDto: DeleteImageDto;
}

export interface UploadImageRequest {
    file?: Blob;
    folder?: string;
}

/**
 * 
 */
export class UploadServiceApi extends runtime.BaseAPI {

    /**
     * Admin delete image from S3
     */
    async deleteImagesRaw(requestParameters: DeleteImagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['deleteImageDto'] == null) {
            throw new runtime.RequiredError(
                'deleteImageDto',
                'Required parameter "deleteImageDto" was null or undefined when calling deleteImages().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("access-token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/upload/image`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: DeleteImageDtoToJSON(requestParameters['deleteImageDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Admin delete image from S3
     */
    async deleteImages(requestParameters: DeleteImagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteImagesRaw(requestParameters, initOverrides);
    }

    /**
     * Admin upload a single image to S3
     */
    async uploadImageRaw(requestParameters: UploadImageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UploadImageResponseDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("access-token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['file'] != null) {
            formParams.append('file', requestParameters['file'] as any);
        }

        if (requestParameters['folder'] != null) {
            formParams.append('folder', requestParameters['folder'] as any);
        }

        const response = await this.request({
            path: `/admin/upload/image`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UploadImageResponseDtoFromJSON(jsonValue));
    }

    /**
     * Admin upload a single image to S3
     */
    async uploadImage(requestParameters: UploadImageRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UploadImageResponseDto> {
        const response = await this.uploadImageRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
